import { useLocation, useParams } from 'react-router-dom';
import { useHostnameTenant } from '../context/HostnameTenantContext';
import { useResolvedTenantPath } from './useResolvedTenantSlug';

export const DEFAULT_TENANT_SLUG = process.env.REACT_APP_DEFAULT_TENANT || 'mvg';

const extractSlugFromPath = (pathname = '') => {
  const segments = pathname.split('/').filter(Boolean);
  return segments[0];
};

export const resolveTenantSlug = (tenantSlug) => {
  if (tenantSlug) return tenantSlug;
  if (typeof window !== 'undefined') {
    const slug = extractSlugFromPath(window.location.pathname);
    if (slug) return slug;
  }
  return DEFAULT_TENANT_SLUG;
};

/**
 * Returns the effective tenant slug.
 * When the hostname has been matched to a tenant, returns the matched slug
 * (ignoring the URL path). Otherwise falls back to the :tenantSlug route param
 * or the first path segment as before.
 */
export const useTenantSlug = () => {
  const { status, tenant } = useHostnameTenant();
  const { tenantSlug } = useParams();
  const { pathname } = useLocation();

  if (status === 'matched' && tenant?.slug) {
    return tenant.slug;
  }

  return tenantSlug || extractSlugFromPath(pathname) || DEFAULT_TENANT_SLUG;
};

/**
 * Returns the effective tenant slug and a `buildPath` helper.
 * Delegates to useResolvedTenantPath (canonical implementation) to ensure
 * both hooks share exactly the same path-building logic.
 */
export const useTenantPath = () => useResolvedTenantPath();
